(() => {
  window.onProductBuyNowClick = function (button) {
    const form = button.form || button.closest('form');
    if (!form || button.disabled || button.getAttribute('aria-disabled') === 'true' || typeof window.onBuyNowClick !== 'function') return;

    const addButton = form.querySelector('[name="add"]');
    if (addButton?.disabled || addButton?.getAttribute('aria-disabled') === 'true') return;
    if (!form.reportValidity()) return;

    const data = new FormData(form);
    const id = String(data.get('id') || '');
    const quantity = Number(data.get('quantity') ?? 1) * Number(data.get('bundle_quantity') ?? 1);
    if (!/^[1-9]\d*$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 1) return;

    const item = { id, quantity };
    const properties = Object.fromEntries(Array.from(data.entries()).flatMap(([name, value]) => {
      const match = name.match(/^properties\[(.+)\]$/);
      return match && typeof value === 'string' ? [[match[1], value]] : [];
    }));
    if (Object.keys(properties).length) item.properties = properties;
    if (data.get('selling_plan')) item.selling_plan = data.get('selling_plan');

    window.onBuyNowClick(button, false, [item]);
  };
})();
